import { masks } from '@/lib/utils'

interface Props {
  value: string
}

function TaxDocumentField({ value }: Props) {
  if (!value) return null

  return value.replace(masks.regex.taxDocument, (all, n1, n2, n3, n4) => `${n1}.${n2}.${n3}-${n4}`)
}

export default TaxDocumentField
